import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PutterType } from '../../api/models';

export type TABLE_TYPE = Table<PutterType>;

export const TABLE = 'putterType';
const SCHEMA = 'putterTypeId, sortId';

class PutterTypeDatabase implements DataRepository<PutterType> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PutterType | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PutterType, key: Key): Promise<PutterType> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PutterType[]): Promise<PutterType[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PutterType[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PutterTypeDB = new PutterTypeDatabase(db);
